const footerGerman = {
  legals: 'Bedingungen & Datenschutz',
  availableLocale: {
    en: 'DE',
    de: 'EN'
  }
};

const footerEnglish = {
  legals: 'Terms & Privacy',
  availableLocale: {
    en: 'DE',
    de: 'EN'
  }
};

export const authGermanLocalization = {
  screens: {
    login: {
      description: 'Verbinde dich mit der Region!',
      button: {
        login: 'Anmelden',
        logout: 'Abmelden',
        signin: 'Neues Konto erstellen',
        completeRegistration: 'Registrierung abschließen',
        completeOnboarding: 'Durchführen'
      },
      ...footerGerman
    },
    registration: {
      'geo-area': {
        title: 'Dein Ort',
        description: 'Wähle deinen Heimatort',
        searchPlaceholder: 'Suche nach PLZ oder Name',
        button: 'Weiter',
        map: 'Wähle den Umkreis, der dich interessiert'
      },
      alert: {
        title: 'Abmelden',
        content:
          'Um mitzufunken, musst du dein Konto noch fertigstellen. Abmelden und später weitermachen?',
        confirm: 'Abmelden',
        cancel: 'Abbrechen'
      }
    },
    error: {
      description:
        'Wir konnten keine Verbindung herstellen.\nBitte überprüfe deine Internetverbindung oder versuche es später erneut.',
      reload: 'Erneut versuchen',
      logout: 'Abmelden',
      support: 'Support',
      ...footerGerman
    },
    'invalid-version': {
      description:
        'Es ist eine neue Version der App verfügbar! Die aktuelle Version der App kann leider nicht mehr verwendet werden.',
      support: 'Support',
      update: 'Update holen',
      ...footerGerman
    }
  }
};

// Guarantees that both translations have the same structure
type AuthorizationLocales = typeof authGermanLocalization;

export const authEnglishLocalization: AuthorizationLocales = {
  screens: {
    login: {
      description: 'Connect yourself with your region!',
      button: {
        login: 'Log in',
        logout: 'Log out',
        signin: 'Create new account',
        completeRegistration: 'Complete registration',
        completeOnboarding: 'Complete'
      },
      ...footerEnglish
    },
    registration: {
      'geo-area': {
        title: 'Your Place',
        description: 'Choose your home area',
        searchPlaceholder: 'Search for postal code or name',
        button: 'Next',
        map: 'Select the area of interest'
      },
      alert: {
        title: 'Log out',
        content:
          'To continue, you need to complete your account. Log out and continue later?',
        confirm: 'Log out',
        cancel: 'Cancel'
      }
    },
    error: {
      description:
        "We couldn't connect.\nPlease check your internet connection or try again later.",
      reload: 'Retry',
      logout: 'Log out',
      support: 'Support',
      ...footerEnglish
    },
    'invalid-version': {
      description:
        'A new version of the app is available. The current version cannot be used anymore.',
      support: 'Support',
      update: 'Update',
      ...footerEnglish
    }
  }
};
